import {
    type LoanRequestNotificationLeadsResolver,
    schemaLoanRequestNotificationLeads,
    type SchemaLoanRequestNotificationLeads,
} from './notificationLeads';

export const schemaLoanRequestResolver_GetActiveUserSetLeads = schemaLoanRequestNotificationLeads;

export type SchemaLoanRequestResolver_GetActiveUserSetLeads = SchemaLoanRequestNotificationLeads;

export type LoanRequestResolver_GetActiveUserSetLeads = LoanRequestNotificationLeadsResolver;
